import { ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAppConfig } from '@/stores/actions/appConfigActions';
import Loading from '@/shared/components/Loading';
import { RootState } from '@/stores';

const direction = (rtl: { direction: string }, location?: { pathname: string }) => (location?.pathname === '/' ? 'ltr' : rtl?.direction);

const MainWrapper = ({ children, location }: { children: ReactNode; location?: { pathname: string } }) => {
    const { rtl, isFetching } = useSelector((state: RootState) => ({
        rtl: state.rtl,
        isFetching: state.appConfig?.isFetching,
    }));

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchAppConfig());
    }, [dispatch]);

    return isFetching ? (
        <Loading loading={isFetching} />
    ) : (
        <div className={`${direction(rtl, location)}-support`} dir={direction(rtl, location)}>
            <div className="wrapper">{children}</div>
        </div>
    );
};

export default MainWrapper;
